// Parses workday open/close time strings into hour floats and computes
// the visible window for the timeline.
//
// Input:  "08:00 AM" / "06:30 PM" (strings as returned by the BE)
// Output: 8 / 18.5 (hour floats)

const FALLBACK = { open: 6, close: 22 };

const parseHourString = str => {
  if (typeof str !== "string") return null;
  const match = str.trim().match(/^(\d{1,2}):(\d{2})\s*(AM|PM)?$/i);
  if (!match) return null;
  let hh = parseInt(match[1], 10);
  const mm = parseInt(match[2], 10);
  const ampm = (match[3] || "").toUpperCase();
  if (ampm === "PM" && hh < 12) hh += 12;
  if (ampm === "AM" && hh === 12) hh = 0;
  return hh + mm / 60;
};

export const resolveWorkdayWindow = workDay => {
  if (!workDay) return { ...FALLBACK, totalH: FALLBACK.close - FALLBACK.open };
  const open = parseHourString(workDay.opensAt);
  const close = parseHourString(workDay.closesAt);
  if (open == null || close == null || close <= open) {
    return { ...FALLBACK, totalH: FALLBACK.close - FALLBACK.open };
  }
  return { open, close, totalH: close - open };
};
